'use client';

import {createContext, useContext} from 'react';

interface NewThemeContextValue {
  applyNewTheme: boolean;
}

export const NewThemeContext = createContext<NewThemeContextValue | undefined>(
  undefined,
);

export const useNewThemeContext = () => useContext(NewThemeContext);
